"use strict";
exports.__esModule = true;
exports.chart_axis_tick_Fill = {
  "name": "--pf-chart-axis--tick--Fill",
  "value": "transparent",
  "var": "var(--pf-chart-axis--tick--Fill, transparent)"
};
exports["default"] = exports.chart_axis_tick_Fill;